import { GET_GEOLOCATION_V2 } from "../../constants/geolocationV2";
import * as feeds from "../../apis/services/feeds";

export const getGeolocationV2 = (url) => {
  return {
    type: GET_GEOLOCATION_V2,
    payload: feeds.getGeolocationV2(url),
  };
};
